
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M11.9999 4C16.9699 4 20.8999 8.56 19.8199 13.72C19.1399 16.95 16.4199 19.46 13.1499 19.92C11.5599 20.14 10.0099 19.91 8.56986 19.22C8.29986 19.09 8.00986 19.03 7.70986 19.03C7.51986 19.03 7.32986 19.06 7.14986 19.11L4.83986 19.79C4.45987 19.9 4.09986 19.55 4.20986 19.16L4.90986 16.77C5.03986 16.32 4.97986 15.85 4.76986 15.42C4.25986 14.34 3.99986 13.18 3.99986 12C3.99986 7.59 7.58986 4 11.9999 4ZM11.9999 2C6.47986 2 1.99986 6.48 1.99986 12C1.99986 13.54 2.35986 14.98 2.96986 16.29L1.50986 21.25C1.28986 22 1.99986 22.71 2.75986 22.48L7.71986 21.02C9.37986 21.81 11.2799 22.17 13.2999 21.91C17.8599 21.32 21.5099 17.56 21.9599 12.99C22.5299 7.03 17.8499 2 11.9999 2Z' fill='#323232'/><path fill-rule='evenodd' clip-rule='evenodd' d='M12 8C11.45 8 11 8.45 11 9V11H9C8.45 11 8 11.45 8 12C8 12.55 8.45 13 9 13H11V15C11 15.55 11.45 16 12 16C12.55 16 13 15.55 13 15V13H15C15.55 13 16 12.55 16 12C16 11.45 15.55 11 15 11H13V9C13 8.45 12.55 8 12 8Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-maps-ugc`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconMapsUgc

    ```js
    <b-new-b-icon-maps-ugc />
    ```
</docs>


